export class Trpmstbill {
  public BILL_LOC!: string;
  public BILL_NO!: string;
  public BILL_MREF!: string;
  public BILL_DATE!: string;
  public BILL_TIME!: string;
  public BILL_PARTYCODE!: string;
  public BILL_AMT!: number;
  public BILL_REMARK!: string;
  public BILL_PUBLISH!: number;
  public BILL_MODE!: string;
  public BILL_SETTAMT!: number;
  public BILL_SETTSTATUS!: string;
  public BILL_DISPATCH!: string;
  public BILL_DISPATCH_LOC!: string;
  public BILL_GST!: boolean;
  public BILL_FROM_DATE!: string;
  public BILL_TO_DATE!: string;
  public CREATEDBY_USERID!: number;
  public UPDATEDBY_USERID!: number;
  public CREATED_DATE!: string;
  public UPDATED_DATE!: string;
  public IS_ACTIVE!: boolean;
}
